export default function AllPages() {
  return <div>test</div>;
}
